export default {
  name: "footLength",
  in: "query",
  required: false,
  description: "name of measure + id of measure object",
  schema: {
    type: "integer",
    example: 180
  }
};
